import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getProductUrl } from '../../../utils/get-line-item-product-url.js';
import '@grandvisionhq/graphql';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import { getLineItemProduct } from './utils/get-line-item-product.js';
import { mapAppliedDiscounts } from './utils/map-applied-discounts.js';
import { mapSubscriptionProperties } from './utils/map-subscription-properties.js';

const mapProductType = (serverType)=>{
    switch(serverType.toLowerCase()){
        case 'frames':
            return 'frames';
        case 'sunglasses':
            return 'sunglasses';
        case 'solutions':
            return 'solutions';
        case 'ready-readers':
            return 'ready-readers';
        case 'accessories':
            return 'accessories';
        default:
            return 'sunglasses';
    }
};
const toBaseLineItem = (serverLineItem, settings, intl)=>{
    const product = getLineItemProduct(serverLineItem);
    return swcHelpers.objectSpread({
        id: serverLineItem.id,
        productUrl: !settings.isReadOnly ? getProductUrl(settings.productLinkFormatter, serverLineItem, getLocalizedString(product.masterData.current.slug, intl.locale), intl.locale) : undefined,
        sku: serverLineItem.sku,
        lineItemId: serverLineItem.id,
        productType: mapProductType(product.productType),
        quantity: `${intl.getLabel('cart.item.quantity')}: ${serverLineItem.quantity}`,
        subtitle: serverLineItem.__typename !== 'LineItemBundle' ? `${getAttribute(serverLineItem.legacyProduct.masterData.current.variant, 'brandModelCode')}` : '',
        price: serverLineItem.price.total.gross,
        originalPrice: serverLineItem.price.total.subtotal,
        discountPrice: serverLineItem.price.total.discount.amount || undefined,
        unitPrice: swcHelpers.objectSpread({
            price: serverLineItem.price.unit.gross,
            originalPrice: serverLineItem.price.unit.subtotal,
            discountPrice: serverLineItem.price.unit.discount.amount || undefined
        }, serverLineItem.price.unit.tax.portions[0] ? {
            tax: serverLineItem.price.unit.tax.portions[0].amount,
            taxRate: serverLineItem.price.unit.tax.portions[0].rate
        } : null, {
            appliedDiscounts: mapAppliedDiscounts(serverLineItem.price.unit.discount.appliedDiscounts, intl)
        }),
        brand: getAttribute(product.masterData.current.variant, 'brand'),
        displayName: getLocalizedString(product.masterData.current.name, intl.locale),
        relativeDiscount: Number((serverLineItem.price.total.discount.percentage * 100).toFixed(2)) || 0
    }, mapSubscriptionProperties(serverLineItem), {
        eligibleInsurance: serverLineItem.eligibleInsurance ? swcHelpers.objectSpread({}, serverLineItem.eligibleInsurance) : undefined,
        insurance: serverLineItem.insurance ? swcHelpers.objectSpread({}, serverLineItem.insurance) : undefined,
        deliveryEstimation: serverLineItem.deliveryEstimation ? swcHelpers.objectSpread({}, serverLineItem.deliveryEstimation) : undefined
    });
};

export { toBaseLineItem };
//# sourceMappingURL=base-line-item.js.map
